import { ComputedPeriodDurationDto } from '../modules/shared/dtos/computed-period-duration.dto';

/**
 * Converts a computed duration to a formatted string.
 *
 * @param duration - The input duration to be formatted.
 * @returns Formatted date string.
 *
 * @example
 * toFormattedDurationString({ months: 1, days: 2 }); // Output: '1mo 2d'
 * toFormattedDurationString({ months: 0, days: 5 }); // Output: '5d'
 * toFormattedDurationString({ months: 3, days: 0 }); // Output: '3mo'
 * toFormattedDurationString({ months: 0, days: 0 }); // Output: ''
 */
export function toFormattedDurationString(
	duration: ComputedPeriodDurationDto,
): string {
	const months = duration?.months ?? 0;
	const days = duration?.days ?? 0;

	let result = '';

	if (months > 0) {
		result += months + 'mo ';
	}

	if (days > 0) {
		result += days + 'd';
	}
	return result;
}
